import { render, staticRenderFns } from "./indexJg.vue?vue&type=template&id=43862096&scoped=true"
import script from "./indexJg.vue?vue&type=script&lang=js"
export * from "./indexJg.vue?vue&type=script&lang=js"
import style0 from "./indexJg.vue?vue&type=style&index=0&id=43862096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43862096",
  null
  
)

export default component.exports